import { render, staticRenderFns } from "./NewViolation.vue?vue&type=template&id=99753f24&"
import script from "./NewViolation.vue?vue&type=script&lang=ts&"
export * from "./NewViolation.vue?vue&type=script&lang=ts&"
import style0 from "./NewViolation.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports